<strong class="h3 d-block mb-2" [id]="elementId" [ngClass]="{ 'visually-hidden': card }">{{ title }}</strong>

<div class="tags" [ngClass]="{ 'is-card': card }" role="group" [attr.aria-labelledby]="elementId">
  @for (tag of tags; track tag) {
    <button
      type="button"
      class="btn btn-light"
      [ngClass]="{ disabled: !filterType }"
      [disabled]="!filterType"
      (click)="search(searchProperty ? tag[searchProperty] : tag, property ? tag[property] : tag)">
      {{ property ? tag[property] : tag }}
    </button>
  }

  @if (suitsAll) {
    <button
      type="button"
      class="btn btn-light disabled"
      [disabled]="true">
      {{ "forms.educationalResource.educationalDetails.common.suitsAllSubjects" | translate }}
    </button>
  }

  @if (hiddenTagsAmount > 0) {
    <button type="button" class="btn btn-light" disabled>+{{ hiddenTagsAmount }}</button>
  }
</div>
